<template>
	<Drawer :value="visible" title="评价详情" width="1126" class-name="review-detail-drawer"
		@on-close="handleClose">
		<div class="drawer-body">
			<!-- ========== 左侧主内容区 ========== -->
			<div class="main-content">

				<!-- 用户信息头部 -->
				<div class="user-header">
					<div class="user-left">
						<img class="avatar" :src="commentDetail.frommember.avatar | default_img" alt="avatar" />
						<div class="user-info">
							<span class="nickname">{{commentDetail.frommember.nickname}}</span>
							<span class="phone">{{commentDetail.frommember.blur_mobile}}</span>
						</div>
					</div>
					<div class="user-right">
						<Tag color="success" class="review-tag">好评</Tag>
						<div class="rate-stars">
							<img v-for="item in commentDetail.rating || 0" src="@/assets/images/icon-mall-collected.png" />
							<img v-for="item in 5 - (commentDetail.rating || 0)" src="@/assets/images/icon-mall-collect.png" />
						</div>
						<span class="review-time">{{commentDetail.create_time}}</span>
					</div>
				</div>

				<!-- 评分维度 -->
				<div class="score-dimensions">
					<div class="dimension-item">
						<span class="dim-label">宝贝与描述相符</span>
						<div class="rate-stars">
							<img v-for="item in commentDetail.description_rating || 0" src="@/assets/images/icon-mall-collected-out.png" />
							<img v-for="item in 5 - (commentDetail.description_rating || 0)" src="@/assets/images/icon-mall-collect.png" />
						</div>
					</div>
					<div class="dimension-item">
						<span class="dim-label">卖家的服务态度</span>
						<div class="rate-stars">
							<img v-for="item in commentDetail.service_rating || 0" src="@/assets/images/icon-mall-collected-out.png" />
							<img v-for="item in 5 - (commentDetail.service_rating || 0)" src="@/assets/images/icon-mall-collect.png" />
						</div>
					</div>
					<div class="dimension-item">
						<span class="dim-label">物流服务的质量</span>
						<div class="rate-stars">
							<img v-for="item in commentDetail.logistics_rating || 0" src="@/assets/images/icon-mall-collected-out.png" />
							<img v-for="item in 5 - (commentDetail.logistics_rating || 0)" src="@/assets/images/icon-mall-collect.png" />
						</div>
					</div>
				</div>

				<!-- 评价正文 -->
				<div class="review-text">
					{{commentDetail.content}}
				</div>

				<!-- 评价图片 -->
				<div class="review-images">
					<div v-for="(img, index) in commentDetail.image_list" :key="index" class="image-item">
						<img v-if="img.type === 'image'" v-viewer :src="img.raw | default_img" alt="评价图片" />
						<img v-if="img.type === 'video'" :src="`${img.raw}?x-oss-process=video/snapshot,t_2000,m_fast,ar_auto`" alt="评价视频" @click.stop="previewVideo(img.raw)" />
						<img v-if="img.type === 'video'" src="@/assets/images/icon-play-evaluate.png" class="video-icon" alt="视频图标" />
					</div>
				</div>

				<!-- 点赞 & 回复统计 -->
				<div class="review-stats">
					<span class="stat-item">
						<img class="stat-icon" src="@/assets/images/icon-mall-goods-detail-useful.png" alt="点赞图标" />
						{{commentDetail.zan_count}}人点赞
					</span>
					<span class="stat-item stat-link" @click="toggleReplyList">
						<img class="stat-icon" src="@/assets/images/icon-mall-goods-detail-comment.png" alt="点赞图标" />
						查看全部{{commentDetail.reply_count}}条用户回复
						<Icon v-if="!showReplyList" type="md-arrow-dropdown" />
						<Icon v-else type="md-arrow-dropup" />
					</span>
				</div>

				<!-- 用户回复列表 -->
				<div v-if="commentDetail.reply_count > 0 && showReplyList" class="reply-list">
					<div v-for="(reply, index) in replyList" :key="index" class="reply-item">
						<div class="reply-header">
							<span class="reply-nickname">{{ reply.frommember.nickname }}</span>
							<span class="reply-time">{{ reply.create_time }}</span>
						</div>
						<div class="reply-content">{{ reply.content }}</div>
					</div>
				</div>

				<div class="divider-row" />

				<!-- 商家回复 -->
				<div class="merchant-reply">
					<div class="reply-label">商家回复</div>
					<div class="reply-input-container">
						<div class="reply-input-wrapper">
							<Input class="reply-input" v-model="merchantReplyText" type="textarea" :rows="4" placeholder="请输入回复内容"
								:maxlength="300" show-word-limit :border="false" :readonly="!!commentDetail.seller_content" style="border: none;" />
							<span class="limit-num">{{merchantReplyText.length}}/300</span>
						</div>
						<div class="reply-tip">
							<span class="tip-dot">*</span>温馨提示：仅可回复评论一次，发表后不可修改
						</div>
					</div>
				</div>
			</div>

			<!-- ========== 右侧边栏 ========== -->
			<div class="side-panel">

				<!-- 关联订单信息 -->
				<div class="panel-section">
					<div class="section-header">
						<span class="section-title">关联订单信息</span>
						<a class="section-link" @click="showOrderDetail(commentDetail.ord)">订单详情 <img src="@/assets/images/icon_more.png" alt="icon_more" /></a>
					</div>

					<!-- 商品卡片 -->
					<div class="product-card">
						<img class="product-img" v-viewer :src="commentDetail.product.image | default_img" alt="product" />
						<div class="product-info">
							<div class="product-name">{{commentDetail.product.name}}</div>
							<div class="product-spec">{{ commentDetail.spec_info }} ×1</div>
						</div>
					</div>

					<!-- 订单字段列表 -->
					<div class="order-fields">
						<div class="field-row">
							<span class="field-label">订单编号：</span>
							<span class="field-value" @click="copyContent(commentDetail.ord.order_no)">
								{{ commentDetail.ord.order_no }}
								<a class="copy-link">复制</a>
							</span>
						</div>
						<div class="field-row">
							<span class="field-label">下单时间：</span>
							<span class="field-value">{{ commentDetail.ord.create_time }}</span>
						</div>
						<div class="field-row">
							<span class="field-label">收货时间：</span>
							<span class="field-value">{{ commentDetail.ord.complete_time }}</span>
						</div>
						<div class="field-row">
							<span class="field-label">实付金额：</span>
							<span class="field-value price">¥{{ commentDetail.ord.real_price }}</span>
						</div>
						<div class="field-row">
							<span class="field-label">收货人：</span>
							<span class="field-value">{{ commentDetail.ord.contact_person }}</span>
						</div>
						<div class="field-row">
							<span class="field-label">联系电话：</span>
							<span class="field-value">{{ commentDetail.ord.contact_mobile }}</span>
						</div>
						<div class="field-row">
							<span class="field-label">收货地址：</span>
							<span class="field-value">{{ commentDetail.ord.province }}{{ commentDetail.ord.city }}{{ commentDetail.ord.zone }}{{ commentDetail.ord.address }}</span>
						</div>
					</div>
				</div>

				<!-- 运营操作 -->
				<div class="opration-section">
					<div class="section-header">
						<span class="section-title">运营操作</span>
					</div>
					<div class="action-buttons">
						<div class="action-btn" @click.stop="onChatClick(commentDetail.frommember)">
							<img src="@/assets/images/icon_comments.png" alt="chat-icon" /> 联系买家
						</div>
						<div class="action-btn" @click.stop="showAppealReviewModal(commentDetail.uuid)">
							<img src="@/assets/images/icon_report.png" alt="report-icon" /> 申述评论
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ========== 底部固定按钮 ========== -->
		<div class="drawer-footer">
			<Button v-if="!commentDetail.seller_content" type="error" class="footer-btn-confirm" @click="handleConfirm">确认回复</Button>
			<Button class="footer-btn-cancel" @click="handleClose">取消</Button>
		</div>
		<chat ref="chat"></chat>
	</Drawer>
</template>

<script>
import { SaveShopReply, GetShopCommentDetail, GetCommentDetail } from "@/api/index";
import util from '@/utils/util';

export default {
	name: 'CommentDetailDrawer',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		comment_uuid: {
			type: String,
			default: ''
		}
	},
	inject: ['showOrderDetail'],
	watch: {
		visible(newVal) {
			if (newVal) {
				console.log('newVal:', newVal);
				this.getShopCommentDetail();
				this.getCommentDetail();
			}
		}
	},
	data() {
		return {
			util,
			merchantReplyText: '',
			commentDetail: {
				frommember: {},
				image_list: [],
				product: {},
				ord: {},
			},
			replyList: [],
			showReplyList: false,
		};
	},
	beforeDestroy() {
		util.closeVideoPreview();
	},
	methods: {
		getShopCommentDetail() {
			GetShopCommentDetail({
				uuid: this.comment_uuid
			}).then(res => {
				if (res.code === 0) {
					this.commentDetail = res.data;
					this.merchantReplyText = res.data?.seller_content || '';
				}
			});
		},
		getCommentDetail() {
			GetCommentDetail({
				uuid: this.comment_uuid
			}).then(res => {
				if (res.code === 0) {
					this.replyList = res.data?.children || [];
				}
			});
		},
		handleClose() {
			this.$emit('update:visible', false);
			this.$emit('close');
		},
		handleConfirm() {
			console.log('商家回复内容:', this.merchantReplyText);
			if (!this.merchantReplyText) {
				this.$Message.warning('请输入回复内容');
				return;
			}
			SaveShopReply({
				uuids: [this.comment_uuid],
				content: this.merchantReplyText,
			}).then(res => {
				if (res.code === 0) {
					this.$Message.success('回复成功');
					this.handleClose();
					this.$emit('confirm');
				}
			});
		},
		previewVideo(url) {
			util.previewVideo(url);
		},
		toggleReplyList() {
			this.showReplyList = !this.showReplyList;
		},
		showAppealReviewModal(uuid) {
			this.handleClose();
			const data = {
				uuid: uuid,
			}
			this.$emit('showAppealReviewModal', data);
		},
		onChatClick(user){
            this.$refs["chat"].showChat(null, user);
        },
        copyContent(orderNo) {
            navigator.clipboard.writeText(orderNo).then(() => {
                this.$layer.msg("复制成功");
            });
        },
	}
};
</script>

<style lang="scss" scoped>
/* ============================================
   整体布局：左右分栏
   ============================================ */
.drawer-body {
	display: flex;
	gap: 24px;
	padding-bottom: 80px; // 给底部按钮留空间
	min-height: 100%;
}

.main-content {
	flex: 1;
	min-width: 0; // 防止 flex 子项溢出
}

.side-panel {
	width: 421px;
	flex-shrink: 0;
	border-left: 1px solid #e3e3e3;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

/* ============================================
   用户信息头部
   ============================================ */
.user-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 11px;

	.user-left {
		display: flex;
		align-items: center;
		gap: 14px;

		.avatar {
			width: 56px;
			height: 56px;
			border-radius: 50%;
			object-fit: cover;
		}

		.user-info {
			display: flex;
			flex-direction: column;
			gap: 4px;

			.nickname {
				font-weight: 400;
				font-size: 16px;
				line-height: 24px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}

			.phone {
				font-weight: 400;
				font-size: 13px;
				line-height: 20px;
				color: #666666;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
		}
	}

	.user-right {
		display: flex;
		align-items: center;

		.review-tag {
			margin-right: 6px;
			height: 21px;
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			vertical-align: middle;
			color: #FFFFFF;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		.rate-stars {
			display: flex;
			// gap: 2px;
			margin-right: 12px;

			img {
				width: 16px;
				height: 16px;
				object-fit: cover;
			}
		}

		.review-time {
			font-weight: 400;
			font-size: 12px;
			color: #999999;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}
	}
}


/* ============================================
   评分维度
   ============================================ */
.score-dimensions {
	display: flex;
	gap: 24px;
	margin-bottom: 15px;

	.dimension-item {
		display: flex;
		align-items: center;
		gap: 4px;

		.dim-label {
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: #999999;
			text-align: right;
			font-style: normal;
			text-transform: none;
		}

		.rate-stars {
			display: flex;

			img {
				width: 14px;
				height: 14px;
				object-fit: cover;
			}
		}
	}
}

/* ============================================
   评价正文
   ============================================ */
.review-text {
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-bottom: 10px;
}

/* ============================================
   评价图片
   ============================================ */
.review-images {
	display: flex;
	gap: 8px;
	margin-bottom: 20px;
	flex-wrap: wrap;

	.image-item {
		position: relative;
		width: 54px;
		height: 54px;
		background: #D9D9D9;
		border-radius: 4px 4px 4px 4px;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.video-icon {
			position: absolute;
			top: 4px;
			right: 4px;
			width: 16px;
			height: 16px;
			object-fit: cover;
		}
	}
}

/* ============================================
   点赞 & 回复统计
   ============================================ */
.review-stats {
	display: flex;
	align-items: center;
	gap: 20px;
	margin-bottom: 8px;

	.stat-icon {
		width: 14px;
		height: 14px;
		object-fit: cover;
	}

	.stat-item {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: #999999;
		text-align: left;
		font-style: normal;
		text-transform: none;

		display: flex;
		align-items: center;
		gap: 4px;
	}

	.stat-link {
		cursor: pointer;

		&:hover {
			color: #2d8cf0;
		}

		.arrow-icon {
			font-size: 6px;
		}
	}
}

/* ============================================
   用户回复列表
   ============================================ */
.reply-list {
	width: 100%;
	max-height: 190px;
	overflow: auto;
	background: #F8F9FB;
	border-radius: 0px 0px 0px 0px;
	padding: 0 16px 8px 16px;
	margin-bottom: 20px;

	.reply-item {
		padding: 10px 0;
		border-bottom: 1px solid #e3e3e3;

		&:last-child {
			border-bottom: none;
		}

		.reply-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 4px;

			.reply-nickname {
				font-weight: 400;
				font-size: 12px;
				line-height: 18px;
				color: #666666;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}

			.reply-time {
				font-weight: 400;
				font-size: 12px;
				line-height: 18px;
				color: #999999;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}
		}

		.reply-content {
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
	}

}

.divider-row {
	width: 100%;
	padding-bottom: 20px;
	border-top: 1px solid #e3e3e3;
}

/* ============================================
   商家回复
   ============================================ */
.merchant-reply {
	display: flex;
	gap: 15px;

	.reply-label {
		flex-shrink: 0;
		margin-top: 10px;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.reply-input-container {
		width: 100%;
	}

	.reply-input-wrapper {
		width: 100%;
		margin-bottom: 8px;
		padding: 11px 16px 29px 16px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #E3E3E3;
		position: relative;

		.reply-input {
			width: 100%;
			height: 100%;
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;

			::v-deep textarea.ivu-input {
				border: none !important;
				box-shadow: none !important;

				:active,
				:focus {
					border: none !important;
					box-shadow: none !important;
				}
			}
		}

		.limit-num {
			position: absolute;
			bottom: 8px;
			right: 10px;
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #B3B3B3;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}

	}

	.reply-tip {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: #999999;
		text-align: left;
		font-style: normal;
		text-transform: none;

		.tip-dot {
			color: #FF5967;
			margin-right: 2px;
		}
	}
}

/* ============================================
   右侧面板 - 通用
   ============================================ */
.panel-section {
	// margin-bottom: 16px;
	flex-shrink: 0;
	padding-left: 32px;
	padding-right: 48px;
	border-bottom: 1px solid #E3E3E3;
}

.opration-section {
	padding-left: 32px;
	padding-right: 48px;
}

.section-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;

	.section-title {
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.section-link {
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 7px;
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: #666666;
		text-align: left;
		font-style: normal;
		text-transform: none;

		&:hover {
			color: #2d8cf0;
		}

		img {
			width: 14px;
			height: 14px;
			object-fit: cover;
		}
	}
}

/* ============================================
   商品卡片
   ============================================ */
.product-card {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 20px;

	.product-img {
		width: 72px;
		height: 72px;
		border-radius: 8px;
		object-fit: cover;
		flex-shrink: 0;
		cursor: pointer;
	}

	.product-info {
		flex: 1;
		min-width: 0;

		.product-name {
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			margin-bottom: 4px;
		}

		.product-spec {
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #666666;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
	}
}

/* ============================================
   订单字段列表
   ============================================ */
.order-fields {
	padding-bottom: 6px;

	.field-row {
		display: flex;
		margin-bottom: 15px;

		.field-label {
			flex-shrink: 0;
			width: 70px;
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: #666666;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}

		.field-value {
			flex: 1;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			text-align: right;
			font-style: normal;
			text-transform: none;

			&.price {
				color: #FF5967;
				font-weight: bold;
			}

			.copy-link {
				color: #0D99FF;
				margin-left: 12px;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
}

/* ============================================
   运营操作按钮
   ============================================ */
.action-buttons {
	display: flex;
	flex-direction: column;
	gap: 10px;

	.action-btn {
		width: 300px;
		height: 40px;
		padding: 10px;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid #E3E3E3;
		display: flex;
		align-items: center;
		justify-content: start;
		gap: 8px;
		cursor: pointer;

		font-weight: 400;
		font-size: 13px;
		color: #333333;
		text-align: right;
		font-style: normal;
		text-transform: none;

		&:hover {
			border: 1px solid #FF5967;
		}

		img {
			width: 18px;
			height: 18px;
			object-fit: cover;
		}
	}
}

/* ============================================
   底部固定按钮栏
   ============================================ */
.drawer-footer {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 18px 16px 22px 70px;
	border-top: 1px solid #e8eaec;
	background: #fff;
	display: flex;
	justify-content: center;
	gap: 16px;
	z-index: 10;

	.footer-btn-confirm {
		width: 196px;
		height: 40px;
		background: #FF5967;
		border-radius: 4px 4px 4px 4px;
	}

	.footer-btn-cancel {
		width: 136px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #E3E3E3;
	}
}
</style>

<!-- 全局样式：覆盖 iView Drawer 默认内边距 -->
<style lang="scss">
.review-detail-drawer {
	.ivu-drawer-header {
		border-bottom: 1px solid #e0e0e0;
		padding: 24px 32px 12px 32px;

		.ivu-drawer-header-inner {
			text-align: left;
			font-weight: bold;
			font-size: 18px;
			color: #0F1115;
			font-style: normal;
			text-transform: none;
		}
	}

	.ivu-drawer-body {
		padding: 24px !important;
		text-align: left;
	}

	.ivu-drawer-close {
		top: 16px;
		right: 20px;
		font-size: 20px;
		color: #999;

		&:hover {
			color: #333;
		}
	}
}
</style>